import { useEffect, useState } from "react";
import { getServerConfig, onConfigChange, fetchUserConfig, decodeToken } from "../utils/roleHelper";
import { isTokenPresent } from "../core/auth";

/**
 * Utente corrente con ruoli, sezioni e capacità, aggiornato quando cambia la
 * configurazione (rinnovo token, permissions:changed). È solo per la UI:
 * l'autorità resta il server.
 */
export function useMe() {
  const [config, setConfig] = useState(() => getServerConfig());
  useEffect(() => {
    const off = onConfigChange(setConfig);
    // Senza sessione (pagine pubbliche) non c'è niente da chiedere al server.
    if (!getServerConfig() && isTokenPresent()) fetchUserConfig().then((c) => !c.fallback && setConfig(c));
    return off;
  }, []);
  const user = config?.user || decodeToken() || {};
  const caps = user.caps || {};
  return {
    user,
    azienda: config?.azienda || null,
    isAdmin: Boolean(user.isAdmin),
    pages: user.pages || [],
    can: (cap) => Boolean(user.isAdmin || caps[cap]),
    hasPage: (p) => Boolean(user.isAdmin || (user.pages || []).includes(p)),
  };
}
